import React from "react";
import "./Notification.css";

export default function Notification({ text }) {
  return <button class="notify popup">{text}</button>;
}
